import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'data-preview-component',
  templateUrl: './data-preview.component.html',
  styleUrls: ['./data-preview.component.scss'],
})
export class DataPreviewComponent implements OnInit {
  selectedPreviewTab = 0;
  showBackToNewTask = false;
  isStarterUser = false;
  sensorTypeFromRoute: string | null = null;
  backTarget: string | null = null;

  @Input() inlineMode = false;
  @Output() backClicked = new EventEmitter<void>();

  constructor(
    @Optional() public dialogRef: MatDialogRef<DataPreviewComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isStarterUser = (this.authService.userValue as any)?.user_plan === 1;
    this.sensorTypeFromRoute = this.route.snapshot.queryParamMap.get('sensorType');
    const source = this.route.snapshot.queryParamMap.get('sensorType');
    this.backTarget = source ? '/whats-new' : null;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  backToNewTask(): void {
    if (this.inlineMode) {
      this.backClicked.emit();
      return;
    }

    if (this.backTarget) {
      this.router.navigate([this.backTarget]);
    }
  }
}
